export const STORAGE_PREFIX = '__klarna_sdk_'

export enum EStorageTypes {
  localStorage = 'localStorage',
  sessionStorage = 'sessionStorage',
  klarnaIframeStorage = 'klarnaIframeStorage',
}
